import {HTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

import Arrow from '@/assets/images/icon-arrow-right.svg?react';
import Button from '@/components/button';
import Spinner from '@/components/spinner';
import {TrackingProps} from '@/components/tracked-atoms/types';
import {BUTTON_THEME, BUTTON_VARIANT} from '@/constants/button';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

type Props = HTMLAttributes<HTMLDivElement> & {
  isLoading?: boolean;
  ['data-testid']?: string;
  label?: string;
  retryLabel?: string;
  retryTrackingKey?: TrackingProps['trackingKey'];
  onRetry?: () => void;
};

export const InvestorAccountsListTransientState = ({
  isLoading,
  ['data-testid']: dataTestId,
  label,
  retryLabel,
  retryTrackingKey,
  onRetry,
  className,
  ...props
}: Props) => {
  return (
    <div
      {...props}
      data-testid={dataTestId}
      className={twMerge(
        clsx('flex h-36 w-full flex-col items-center justify-center rounded-2 bg-gray-100', className),
      )}
    >
      {isLoading ? (
        <Spinner className="size-6" />
      ) : (
        <>
          <div>{label}</div>
          {onRetry && (
            <Button
              data-testid="accounts-retry-button"
              theme={BUTTON_THEME.STYLELESS}
              variant={BUTTON_VARIANT.X_SMALL}
              icon={<Arrow className="size-4 fill-violet" />}
              label={retryLabel}
              trackingKey={retryTrackingKey ?? WEB_CLICK_TRACKING_KEY.DISABLED}
              onClick={onRetry}
            />
          )}
        </>
      )}
    </div>
  );
};
